<template>
  <header
    class="
    bg-gradient-to-b
    border-b
    border-b-secondary-800
    dark:border-b-secondary-950
    dark:shadow-neutral-950
    flex
    from-secondary-600
    dark:from-secondary-800
    to-secondary-700
    dark:to-secondary-900
    isolate
    items-center
    justify-center
    h-(--application-page-header-height-sm)
    md:h-(--application-page-header-height-md)
    lg:h-(--application-page-header-height-lg)
    xl:h-(--application-page-header-height-xl)
    2xl:h-(--application-page-header-height-2xl)
    relative
    shadow-secondary-200/50
    shadow-lg
    "
  >
    <slot />
  </header>
</template>
